// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var RcSlider = require("rc-slider");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var NumberFilter$ReactHooksTemplate = require("./numberFilter.res.js");
var NumberSelected$ReactHooksTemplate = require("./numberSelected.res.js");

function NumberFilterForm(props) {
  var onChange = props.onChange;
  var filter = props.filter;
  var handleOnChange = function (value) {
    Curry._1(onChange, {
          TAG: "Number",
          _0: NumberFilter$ReactHooksTemplate.setSelected(Caml_option.some(NumberSelected$ReactHooksTemplate.make(Belt_Array.get(value, 0), Belt_Array.get(value, 1))), filter)
        });
  };
  var displayRange = function (min$p, max$p) {
    var min = Belt_Option.getWithDefault(min$p, 0);
    var max = Belt_Option.getWithDefault(max$p, 100);
    return JsxRuntime.jsx(RcSlider.Range, {
                className: "p-2 text-sm",
                min: min,
                max: max,
                allowCross: false,
                defaultValue: [
                  min,
                  max
                ],
                onChange: handleOnChange
              });
  };
  return JsxRuntime.jsx("label", {
              children: displayRange(NumberFilter$ReactHooksTemplate.getMin(filter), NumberFilter$ReactHooksTemplate.getMax(filter))
            });
}

var className = "border border-gray-200 hover:border-gray-400 focus:border-teal-500 outline-none w-full py-10-px px-1 text-sm bg-transparent";

var make = NumberFilterForm;

exports.className = className;
exports.make = make;
/* rc-slider Not a pure module */
